import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Award, Headphones, Truck, ShieldCheck } from 'lucide-react';
import siteData from '@/data/siteData.json';

const iconMap = {
  Award: Award,
  Headphones: Headphones,
  Truck: Truck,
  ShieldCheck: ShieldCheck,
};

export const Features = () => {
  return (
    <section id="sobre" className="py-20 md:py-28 bg-secondary">
      <div className="section-container">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Por que nos escolher
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            Excelência em Automação Industrial
          </h2>
          <p className="text-muted-foreground text-base md:text-lg">
            Há mais de 15 anos fornecendo as melhores soluções para automação de
            processos industriais
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {siteData.features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon] || Award;
            return (
              <Card
                key={feature.id}
                className="card-industrial bg-card group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CardContent className="p-6 flex flex-col h-full">
                  <div className="w-14 h-14 rounded-xl bg-primary/5 flex items-center justify-center mb-5 group-hover:bg-primary/10 transition-colors">
                    <IconComponent className="h-7 w-7 text-primary" />
                  </div>
                  <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
